import React, { useState } from "react";
import cx from "classnames";
import Dropzone from "react-dropzone";

import Icon from "../Icon/Icon";
import s from "./FileUpload.module.scss";
import AppMessages from "../../AppMessages";
import AppConfig from "../../AppConfig";

const FileUpload = ({
	isPublic,
	title = "",
	placeholderText = "",
	infoText,
	verifyContent = () => {},
	onFileChange = () => {},
	accept,
	customTitle = null,
	fileName = null,
	inputStyle = "",
}) => {
	const [hasFile, setHasFile] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const acceptFilters = accept;

	const maxSize = 1048576;

	const confirmText = "Looks good!";
	const defaultText =
		placeholderText || "ex. 123 " + AppConfig.samplePrivateKeyFile;
	const titleText = title
		? title
		: isPublic
		? AppMessages.PublicKeyLabel
		: AppMessages.PrivateKeyLabel;

	const onDrop = async (files) => {
		setErrorMessage(null);

		if (files.length === 0) {
			setErrorMessage("File could not be loaded!");
			setHasFile(false);
			return onFileChange(null);
		}

		setSelectedFile(files[0]);
		setHasFile(files.length > 0);

		const reader = new FileReader();
		reader.onload = (e) => {
			const content = e.target.result;
			let error = verifyContent(content);
			if (error != null) {
				setErrorMessage(error);
			} else {
				setErrorMessage(null);
				onFileChange(content, files[0]?.name);
			}
		};
		reader.readAsText(files[0]);
	};

	return (
		<div className={s.root}>
			<div className={s.section}>
				{customTitle ? (
					customTitle
				) : (
					<div className={s.titleContainer}>
						<Icon icon={isPublic ? "globe" : "lock"} />

						<div className={s.title}>
							{titleText}
							<span className="mandatory"> *</span>
						</div>
					</div>
				)}
			</div>

			<div className={s.container}>
				<div className={s.uploadWidget}>
					<Dropzone
						onDrop={onDrop}
						multiple={false}
						accept={acceptFilters}
						minSize={0}
						maxSize={maxSize}
					>
						{(props) => {
							const {
								getRootProps,
								getInputProps,
								isDragActive,
								isDragReject,
								fileRejections,
							} = props;

							// While dragging allow all file types
							//setAcceptFilters(isDragActive ? null : accept);

							const isFileTooLarge =
								!isDragActive &&
								fileRejections?.length > 0 &&
								fileRejections[0].file?.size > maxSize;

							let error = errorMessage || "";
							if (isFileTooLarge) error = "File is too large, sorry!";
							if (isDragReject) {
								error =
									"Your file doesn’t contain a key, please try a different file.";
							}

							return (
								<div
									{...getRootProps()}
									className={cx(
										s.uploadInput,
										isDragActive
											? s.hover
											: isFileTooLarge || isDragReject
											? s.invalid
											: selectedFile
											? s.valid
											: ""
									)}
								>
									<input {...getInputProps()} />

									{!isDragActive &&
										(selectedFile?.name ? (
											<p className={cx(s.fileName, inputStyle)}>
												{selectedFile.name}
											</p>
										) : !!fileName ? (
											<p className={cx(s.fileName, inputStyle)}>{fileName}</p>
										) : (
											<p className={s.placeholder}>{defaultText}</p>
										))}

									{isDragActive && !isDragReject && (
										<p className={s.placeholder}>Drop file here</p>
									)}

									<div className={s.icons}>
										{hasFile && <Icon icon="check" className={s.checkIcon} />}

										<div className={cx(s.iconContainer)}>
											<Icon icon={isDragActive ? "plus" : "upload"} />
										</div>
									</div>

									<div className={s.uploadInfo}>
										{error ? (
											<p className={cx(s.caption, s.error)}>{error}</p>
										) : hasFile ? (
											<p className={s.caption}>{confirmText}</p>
										) : (
											<p className={s.info}>{infoText}</p>
										)}
									</div>
								</div>
							);
						}}
					</Dropzone>
				</div>

				{/* {errorMessage ? (
					<p className={cx(s.caption, s.error)}>{errorMessage}</p>
				) : hasFile ? (
					<p className={s.caption}>{confirmText}</p>
				) : (
					<p className={s.info}>{infoText}</p>
				)} */}
			</div>
		</div>
	);
};
export default FileUpload;
